import { render, staticRenderFns } from "./MaxLengthCounter.vue?vue&type=template&id=6abbdc80&scoped=true"
import script from "./MaxLengthCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./MaxLengthCounter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MaxLengthCounter.vue?vue&type=style&index=0&id=6abbdc80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abbdc80",
  null
  
)

export default component.exports